var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 149.2 134",
    enableBackground: "new 0 0 149.2 134",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "M10.4,131.9c-2.2,0-4.4-0.9-6-2.7c-2.9-3.3-2.6-8.3,0.7-11.3l57.7-51.3L5.1,15.4c-3.3-2.9-3.6-8-0.7-11.3 s8-3.6,11.3-0.7l64.4,57.3c1.7,1.5,2.7,3.7,2.7,6c0,2.3-1,4.5-2.7,6l-64.4,57.3C14.2,131.3,12.3,131.9,10.4,131.9z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "M138.7,131.9c-1.9,0-3.8-0.7-5.3-2L69,72.6c-1.7-1.5-2.7-3.7-2.7-6c0-2.3,1-4.5,2.7-6l64.4-57.3 c3.3-2.9,8.3-2.6,11.3,0.7c2.9,3.3,2.6,8.3-0.7,11.3L86.4,66.7L144,118c3.3,2.9,3.6,8,0.7,11.3C143.1,131,140.9,131.9,138.7,131.9z "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.30040357f3b8185101bd67b66c7b86eb.svg";
export { ForwardRef as ReactComponent };